import { Currency } from './billing.config'

// Whether an "Add card" click should open the two-step first-card WIZARD
// (billing address, then card) instead of the plain add-card modal.
//
// The wizard collects US billing-address fields (state / ZIP) and its card step
// posts to the STRIPE add-card endpoint (`useAddCardOrCashfreePayMutation` ->
// `billingService.addCard`), so routing a non-US org there hands an Indian
// customer a US address form and a Stripe card form. `settings/payment-modes`
// already guarded this with an `isUSOrg` conjunct; `overview/recharge-modal` did
// not, which is the second half of the new-INR-account bug — a first-card INR
// user (no cards AND no billing address) reached the wizard even after the
// gateway fork was fixed, because `AddCardModal`'s Razorpay branch is the one
// this path skips.
//
// `accountCurrency` is `accountDetails?.account?.currency`, i.e. UNDEFINED while
// the query is in flight. That case returns false: unresolved currency must not
// route to the US wizard, for the same reason useBillingGateway fails to
// 'stripe' rather than guessing INR. (payment-modes' inline `isUSOrg` treated a
// LOADED account with an empty currency as US; this treats it as unknown, which
// is the safer of the two and the only behavioural difference.)
export const shouldUseFirstCardWizard = ({
  accountCurrency,
  cardCount,
  hasBillingZipcode,
}: {
  accountCurrency?: string
  cardCount: number
  hasBillingZipcode: boolean
}): boolean => {
  if (!accountCurrency) return false
  return accountCurrency !== Currency.INR && cardCount === 0 && !hasBillingZipcode
}
